import { useCallback, useLayoutEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CustomTabs } from "../shared/CustomTabs";
import { CustomModal } from "../shared/CustomModal";
import Navbar from "../components/dashboard/Navbar";
import Sidebar from "../components/dashboard/Sidebar";
import classIcon from "../assets/images/classs-img.png";
import { ModalPortal } from "../components/ModalPortal";
import { Usage } from "../shared/book_detail_tabs/Usage";
import { Authors } from "../shared/book_detail_tabs/Authors";
import { Reviews } from "../shared/book_detail_tabs/Reviews";
import { Overview } from "../shared/book_detail_tabs/Overview";
import {
  getBookByID,
  updateBookStatus,
  updateBookDetails,
  getBooksList,
  addBookToClass,
} from "../Store/api/books";
import { CustomSelect } from "../shared/CustomSelect";
import { useSelector } from "react-redux";

const tabs = ["overview", "authors", "usage", "reviews", "history"];
const modalVariations = {
  draft: {
    title: "book must be published to share",
    content:
      "To share with other professors, make sure your book is ready to be published to the Greyled library.",
    otherContent:
      "Are you trying to invite an author or collaborator? Invite others by email to work on the book, found under the authors tab.",
    actionBtnText: "Publish to the Greyled",
    cancelBtnText: "Back to book overview",
  },
  published: {
    title: "Share on Greyled",
    content:
      "Greyled is about collaborating with other professors. Sharing all activities created within this book helps other OER professors and provides the best teaching experience.",
    actionBtnText: "Share all activites",
    cancelBtnText: "Go back",
  },
};

const indicatorSeparatorStyle = {
  alignSelf: "stretch",
  marginBottom: 8,
  marginTop: 8,
  width: 0,
};

const IndicatorSeparator = ({ innerProps }) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

const CustomSingleValue = ({ data }) => (
  <>{data.isLink ? <Link to={data.value}>{data.label}</Link> : data.label}</>
);

const BookOverview = () => {
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const [tab, setTab] = useState("overview");
  const [bookObj, setBookObj] = useState({});
  const [classes, setClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentClass, setCurrentClass] = useState({});
  const [statusLoader, setStatusLoder] = useState(false);
  const [showClassRoomModal, setShowClassRoomModal] = useState(false);

  const options = [
    {
      label: "No classrooms available",
      value: "",
    },
    {
      label: (
        <Link
          to={`/signup/createclass/?bookId=${id}`}
          className="text-purple text-decoration-underline fw-semibold"
        >
          Create new class
        </Link>
      ),
      value: "",
    },
  ];

  useLayoutEffect(() => {
    dispatch(
      getBooksList({
        onSuccess: (res) => {
          const list =
            res?.data?.map((item) => ({
              label: item.courseName,
              value: item._id,
            })) || [];
          if (list.length) options.splice(0, 1);
          setClasses([...list, ...options]);
        },
      })
    );
    dispatch(
      getBookByID({
        id,
        onSuccess: (res) => {
          const { data = {} } = res;
          setLoader(false);
          setBookObj({
            ...data,
            yearPublished: new Date(data.yearPublished)
              .getFullYear()
              .toString(),
          });
        },
        onError: () => {
          setLoader(false);
          toast.error("Error while fetching book details.");
        },
      })
    );
  }, [dispatch, id]);

  const handleTabChange = (item) => setTab(item);
  const onToggle = useCallback(() => {
    setShowModal((prev) => !prev);
  }, []);

  const handleClick = () => {
    setShowClassRoomModal(true);
  };

  const handleStatusUpdate = (status) => {
    const promise = new Promise((resolve, reject) =>
      dispatch(
        updateBookStatus({
          id,
          status,
          onSuccess: (res) => {
            const { data = {} } = res;
            setBookObj(data);
            resolve();
          },
          onError: () => {
            reject();
          },
          onEnd: () => {},
        })
      )
    );

    toast.promise(promise, {
      pending: "Book status update in progress",
      success: "Book status updated successfully",
      error: "Error while updating book status",
    });
  };

  const bookUpdate = (data) => {
    const promise = new Promise((resolve, reject) =>
      dispatch(
        updateBookDetails({
          id,
          body: data,
          onSuccess: (res) => {
            const {
              data: {},
            } = res;
            setBookObj({
              ...bookObj,
              ...data,
              yearPublished: new Date(data.yearPublished)
                .getFullYear()
                .toString(),
            });
            resolve();
          },
          onError: () => {
            reject();
          },
          onEnd: () => {},
        })
      )
    );
    toast.promise(promise, {
      pending: "Book details update in progress",
      success: "Book updated successfully",
      error: "Error while updating book details",
    });
  };

  const onToggleModal = () => {
    setStatusLoder(false);
    setCurrentClass({});
    setShowClassRoomModal(false);
  };

  const removeItem = () => {};
  const handleAddToClass = () => {
    if (!currentClass?.value)
      return toast.error("please select class to add book in it.");
    setStatusLoder(true);
    dispatch(
      addBookToClass({
        body: {
          bookId: id,
          classId: currentClass.value,
        },
        onSuccess: () => {
          toast.success("Book attached to classroom successfully.");
          dispatch(
            getBookByID({
              id,
              onSuccess: (res) => {
                const { data = {} } = res;
                setLoader(false);
                setBookObj({
                  ...data,
                  yearPublished: new Date(data.yearPublished)
                    .getFullYear()
                    .toString(),
                });
              },
              onError: () => {
                setLoader(false);
                toast.error("Error while fetching book details.");
              },
            })
          );
          onToggleModal();
        },
        onError: () => {
          toast.error("Error while use book in classroom.");
        },
      })
    );
  };

  return (
    <>
      <ModalPortal>
        <CustomModal
          onHide={onToggle}
          // loading={loading}
          showModal={showModal}
          onAction={removeItem}
          {...modalVariations[
            ["private", "draft"].includes(bookObj.bookStatus)
              ? "draft"
              : "published"
          ]}
        />
      </ModalPortal>
      <ModalPortal>
        <CustomModal
          onHide={onToggleModal}
          loading={statusLoader}
          cancelBtnText="Go back"
          onAction={handleAddToClass}
          title="use book in classroom"
          showModal={showClassRoomModal}
          actionBtnText="Add book to class"
          content={
            <div className="d-flex flex-column gap-3">
              <p className="m-0 p-0">
                Select which classroom you want to add and use this book in. The
                selected classroom will have it’s book{" "}
                <span className="m-0 fw-500">replaced</span> and put into a{" "}
                <b className="text-grey">DRAFT</b> state within your bookshelf.
              </p>
              <p className="m-0 fw-semibold">
                All assigned activities and any student progress on activities
                will be removed.
              </p>
            </div>
          }
        >
          <div className="form-group mb-0 w-100">
            <CustomSelect
              customStyle={{
                control: (base, state) => ({
                  ...base,
                  border: "none !important",
                  background: "#fafaf9",
                  boxShadow: "none",
                  borderBottom: state.isFocused
                    ? "1px solid #2e2e2d !important"
                    : "1px solid #2e2e2d !important",
                  "&:hover": {
                    borderBottom: "1px solid #2e2e2d", // Keep border on hover
                  },
                }),
                menu: (provided) => ({
                  ...provided,
                  marginTop: 0, // This removes the gap between control and dropdown
                  border: "1px solid grey"
                }),
              }}
              isClearable={false}
              className="w-100 mb-0"
              placeholder="Select class"
              value={classes.filter(
                (item) => item.value === currentClass.value
              )}
              options={classes}
              handleChange={(value) => {
                setCurrentClass(value);
              }}
              components={{
                IndicatorSeparator,
                SingleValue: CustomSingleValue,
              }}
            />
          </div>
        </CustomModal>
      </ModalPortal>
      <div className="wrapper">
        <Sidebar userType="teacher" sideBarEvent="bookshelf/overview" />
        <div id="content">
          <div className="content_dashborad_inner h-100">
            <Navbar sideBarEvent="bookshelf" />
            <div className="main_section_content flex-column gap-32">
              <div className="d-flex flex-wrap gap-40 pt-3">
                <div className="d-flex flex-column gap-12">
                  <div className="overview-status d-flex align-items-center gap-1">
                    {loader ? (
                      <h4 className="content-skeleton m-0 w-100"></h4>
                    ) : (
                      <>
                        <img
                          className="cursor"
                          src="/assets/images/arrow-left.png"
                          alt="back to book icon"
                          width={20}
                          height={20}
                          onClick={() => navigate("/dashboard/bookshelf")}
                        />
                        <span
                          className={`fw-bold text-uppercase ${
                            bookObj.bookStatus === "private"
                              ? "text-green"
                              : "text-purple"
                          }`}
                        >
                          {bookObj.bookStatus || ""}
                        </span>
                      </>
                    )}
                  </div>
                  <div className="book-img-container w-100">
                    {loader ? (
                      <h4 className="content-skeleton m-0"></h4>
                    ) : (
                      <img
                        className=""
                        src={bookObj.coverImage || bookObj?.bookDetailCoverUrl || classIcon}
                        alt="class pic"
                        width={145}
                        height={195}
                      />
                    )}
                  </div>
                </div>
                <div className="d-flex flex-column justify-content-start align-items-start w-70">
                  <div className=" book-content-container d-flex flex-column gap-12 justify-content-start align-items-start w-100">
                    {loader ? (
                      <h4 className="content-skeleton m-0 w-75"></h4>
                    ) : (
                      <div className="breadcrumb fw-semibold mb-0">{`${
                        bookObj.categoryType || "Category"
                      } / ${bookObj?.subjects?.join(", ") || "Subjects"}`}</div>
                    )}
                    <div className="textbook-container p-0 m-0 w-100">
                      <BookOriginalDetails loading={loader} details={bookObj} />
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="btn-container d-flex gap-4 actions mt-3 w-50">
                          {loader ? (
                            <h4 className="content-skeleton m-0 w-80"></h4>
                          ) : (
                            <>
                              <button
                                className="book_detail_action_button book_shelft_detail_action_button_text mb-0"
                                onClick={handleClick}
                              >
                                Use in classroom
                              </button>
                              <button
                                className="book_detail_action_button_share book_shelft_detail_action_button_text mb-0"
                                onClick={onToggle}
                              >
                                Share
                              </button>
                            </>
                          )}
                        </div>
                        <BookRemixedDetails
                          loading={loader}
                          bookObj={bookObj}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="d-flex flex-column justify-content-start gap-12">
                    <BookRemixedDetails />
                  </div> */}
              </div>
              <CustomTabs
                tabs={tabs}
                currentTab={tab}
                handleTabChange={handleTabChange}
              >
                <div className="d-flex flex-column gap-3 mt-3 h-dv-58 overflow-scroll">
                  {tab === "overview" && (
                    <Overview
                      loader={loader}
                      bookObj={bookObj}
                      handleBookUpdate={bookUpdate}
                      handleStatusUpdate={handleStatusUpdate}
                    />
                  )}
                  {tab === "authors" && <Authors bookObj={bookObj} />}
                  {tab === "usage" && <Usage />}
                  {tab === "reviews" && <Reviews />}
                  {tab === "history" && <div></div>}
                </div>
              </CustomTabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookOverview;

export const BookOriginalDetails = ({ loading = false, details = {} }) => {
  return (
    <>
      {loading ? (
        <h4 className="content-skeleton m-0 w-100"></h4>
      ) : (
        <h1 className="fs-5 fw-bold mt-0">
          {details.title || "Title of the textbook"}
        </h1>
      )}
      <div className="details">
        <div className="detail-content w-100">
          Written by:
          {loading ? (
            <h4 className="content-skeleton m-0 w-75"></h4>
          ) : (
            <span>{`${details.author || "Author Name"}, ${
              details.universityName || "University Name"
            }`}</span>
          )}
        </div>
        <div className="detail-content w-100">
          Year published:{" "}
          {loading ? (
            <h4 className="content-skeleton m-0 w-75"></h4>
          ) : (
            <span>{details.yearPublished}</span>
          )}
        </div>
        <div className="detail-content w-100">
          Publisher:
          {loading ? (
            <h4 className="content-skeleton m-0 w-75"></h4>
          ) : (
            <span>{`${details.publisher || "Unkown"}`}</span>
          )}
        </div>
        <div className="detail-content w-100">
          Language:
          {loading ? (
            <h4 className="content-skeleton m-0 w-75"></h4>
          ) : (
            <span>{`${details.language || "English"}`}</span>
          )}
        </div>
      </div>
    </>
  );
};

export const BookRemixedDetails = ({ loading = false, bookObj }) => {
  const { licenses } = useSelector(
    (state) => state.entities.bookFelids.bookFields
  );
  const current_license = licenses.filter(
    (item) => item.label === bookObj.license
  )?.[0];

  return (
    <div className="textbook-container p-0 m-0">
      {/* <h1 className="fs-5 fw-500 mt-0">Original Title of the textbook</h1> */}
      {/* <div className="details">
        <p className="m-0">
          Written by: <span>Author Name, University Name</span>
        </p>
        <p className="m-0">
          Year published:{" "}
          <span>{new Date().getFullYear()}</span>
        </p>
        <p className="m-0">
          Publisher: <span>Unkown</span>
        </p>
        <p className="m-0">
          Language: <span>English</span>
        </p>
      </div> */}
      <div className="conditions-of-use mb-0 mt-2">
        <p className="fw-500">Conditions of Use</p>
        {loading ? (
          <h4 className="content-skeleton m-0 w-100"></h4>
        ) : (
          <div className="licenses">
            {current_license?.img_url && (
              <img src={current_license.img_url} alt="CC" />
            )}
            {current_license?.img_url2 && (
              <img src={current_license.img_url2} alt="BY" />
            )}
            {current_license?.img_url3 && (
              <img src={current_license.img_url3} alt="NC" />
            )}
            <p>
              <u>Attribution-NonCommercial</u>
              <br />
              {current_license?.label ?? ""}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
